<script>
    export let menu;
</script>
{#if menu}
<div class="home_block_box_bg restaurant_food restaurant_food_print wpb_column vc_column_container vc_col-sm-12">
    <div class="vc_column-inner ">
        <div class="wpb_wrapper">
            <div class="menu mm-row">
                <div class="menu-category list-group ">
                    <div>
                        <ul class="menu_list_item">
                            {#each menu.submenu as submenu}
                                <h4>{submenu.name}</h4>
                                {#each submenu.items as item}
                                    <li>
                                        {#if menu.name == "RESTAURANT"}
                                            <img src="/images/{item.nonveg == 1? 'non_' : ''}veg.png" class="veg_non_veg_img" alt="" />&nbsp;
                                        {/if}
                                        {item.item_name} &nbsp;&nbsp;₹ <span class="item_price">{item.cost}</span>
                                    </li>
                                {/each}
                            {/each}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
{/if}
<style>
    h4 {
        background: #967a50;
        border-radius: 20px;
        color: #fff;
        font-size: 20px;
        padding: 0;
        text-align: center;
        margin: 10px 0;
    }

    .menu_list_item li {
        font-size: 16px;
        line-height: 28px;
        list-style: outside none none;
    }

    .mm-row:before {
        display: table;
        content: " ";
    }

    :global(.mm-row) {
        padding: 10px;
        -moz-column-width: 224px;
        -webkit-column-width: 224px;
    }
</style>